import { render } from "./BookingsUnderApprovalList.vue?vue&type=template&id=0cfccfac&scoped=true"
import script from "./BookingsUnderApprovalList.vue?vue&type=script&lang=js"
export * from "./BookingsUnderApprovalList.vue?vue&type=script&lang=js"

import "./BookingsUnderApprovalList.vue?vue&type=style&index=0&id=0cfccfac&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfccfac"]])

export default __exports__